import { useState } from 'react';
import { Box, Text } from '@qga/roo-ui/components';

import Button from '@/components/Button';
import { useFlightModal } from '@/v2/components/pages/PackageViewV2/contexts/FlightModalContext';
import { viewOtherOptionsDataLayerEvent } from '@/v2/components/pages/PackageViewV2/utils/dataLayer';
import { Divider } from '@/v2/components/ui/Divider';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import { UI } from '@/v2/types';
import { dataLayer } from '@/v2/utils/dataLayer';
import OfferModal from '../OfferModal';

export type OtherOptionProps = {
  upgradeOffer?: UI.RoomOptionOffer;
  selectedRoomOption?: UI.RoomOption;
  propertyContent: UI.Property;
  procuredOffer?: UI.ProcuredOffer;
};

const OtherOption = ({
  upgradeOffer,
  selectedRoomOption,
  propertyContent,
  procuredOffer,
}: OtherOptionProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const shouldUseNewEvents = useGA4Events();

  const { openFlightModal } = useFlightModal({
    roomId: selectedRoomOption?.roomType.id,
  });

  const handleUpgrade = async () => {
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: 'Upgrade package',
      });
    }
    await openFlightModal({
      offerId: upgradeOffer?.hotelOffer.id,
    });
    setIsModalOpen(false);
  };

  return !!upgradeOffer ? (
    <>
      <Box display={['none', null, 'initial']}>
        <Divider my="0" width="100%" />
      </Box>
      <Box mt={['4', null, '0']}>
        <Button
          width="100%"
          variant="auxiliary"
          data-testid="OTHER_OPTION_CTA"
          onClick={() => {
            viewOtherOptionsDataLayerEvent();
            setIsModalOpen(true);
          }}
        >
          <Text display={['initial', null, 'none']}>1 other option</Text>
          <Text display={['none', null, 'initial']}>View 1 other option</Text>
        </Button>
      </Box>
      <OfferModal.OtherOption
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSubmit={handleUpgrade}
        onClose={() => setIsModalOpen(false)}
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
        offer={upgradeOffer}
        roomType={selectedRoomOption?.roomType}
      />
    </>
  ) : null;
};

export default OtherOption;
